;(function (angular, _) {
  'use strict'
  angular.module('kilo.routes.bpu.show')
    .controller('ArchiveBpuModalController', ArchiveBpuModalController)

  ArchiveBpuModalController.$inject = [
    // Angular
    // Libs
    '$uibModalInstance'
    // Managers
    // Services
    // Const
    // Resolved
  ]

  function ArchiveBpuModalController (
    // Angular
    // Libs
    $uibModalInstance
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes
        confirmationWord: '',
        // Public Method
        checkValue: checkValue
      })
    }

    function checkValue () {
      if (!self.confirmationWord) {
        return true
      }
      return self.confirmationWord.toLowerCase() !== 'confirmer'
    }
  }
})(window.angular, window._)
